import React from 'react';

import { defaultStrings } from 'js/config/config';

import { criteriaActions } from 'actions/CriteriaActions';
import { mapActions } from 'actions/MapActions';

export class ResultsButton extends React.Component {
  constructor(props) {
    super(props);
  }

  handleClick() {
    if (!this.props.readyForReport) {
      return;
    }
    criteriaActions.viewReport();
    mapActions.showLegend();
  }

  render() {
    let reportButtonText = '';
    if (this.props.warning.show) {
      reportButtonText = this.props.warning.text;
    } else {
      reportButtonText = defaultStrings.resultsInstruction;
    }

    return (
      <div id='resultsButton' className='white padding--small margin--small'>
        <a
          onClick={this.handleClick.bind(this)}
          className={`waves-effect waves-light btn-large blue darken-4 fill__wide ${
            this.props.readyForReport ? '' : 'disabled'
          }`}
        >
          {reportButtonText}
        </a>
      </div>
    );
  }
}
